import React from 'react';
import './CoachingReviewStatusRibbon.styl';
import ClickableHelpIcon from 'components/pure/utils/ClickableHelpIcon';
import {EyeIcon} from '@components/icon/EyeIcon';
import {FlagIcon} from '@components/icon/FlagIcon';

interface Props {
  isPrepping: boolean;
  inProgress: boolean;
  narrow: boolean;
}

/**
 * Ribbon to display status of coaching review. either previewing, in progress, or prepping.
 * Supports narrow mode in case we dont have room to display the copy.
 *
 * @param isPrepping
 * @param inProgress
 * @param narrow
 * @param children
 * @return {JSX.Element}
 * @constructor
 */
const CoachingReviewStatusRibbon: React.FC<Props> = ({
  isPrepping,
  inProgress,
  narrow,
  children,
}) => {
  let heading = 'Preview Mode';
  let icon = <EyeIcon />;
  let copy = '';
  let color = '#ecf6fc';

  // note here - prepping is a narrowing/more specific version of inProgress
  if (isPrepping) {
    heading = 'Meeting Preparation';
    icon = <FlagIcon />;
    copy = "- time you spend answering questions doesn't count towards meeting time.";
    color = '#FCF0EC';
  } else if (inProgress) {
    heading = 'In Progress';
    icon = <FlagIcon />;
    color = '#FCF0EC';
  }

  const helpIcon =
    !isPrepping && !inProgress && narrow ? (
      <ClickableHelpIcon
        className="start-and-prep-button-help"
        text={() =>
          'Click start/prep to enable questions. Start Meeting will count meeting time. You can only hold a meeting once. Prepare for Meeting will not start the meeting, and not count meeting time.'
        }
      />
    ) : null;

  return (
    <div className="in-progress-ribbon" style={{backgroundColor: color}}>
      <div className={'in-progress-info'}>
        {icon}
        <h2>{heading}</h2>
        {helpIcon}
        {copy && !narrow && <span>{copy}</span>}
      </div>
      {children}
    </div>
  );
};

export default CoachingReviewStatusRibbon;
